import { render, staticRenderFns } from "./FccComplementoSolicitacao.vue?vue&type=template&id=1c22f4ba"
import script from "./FccComplementoSolicitacao.vue?vue&type=script&lang=js"
export * from "./FccComplementoSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports